import { createIcon } from "@chakra-ui/react";

export const Challenging = createIcon({
  displayName: "Challenging",
  viewBox: "0 0 24 24",
  path: [
    <path
      fill="#FFBC58"
      d="M2.625 12a9.376 9.376 0 1 0 18.751 0 9.376 9.376 0 0 0-18.751 0zm4.063-3.75c0-.172.14-.313.312-.313h2.5a.313.313 0 0 1 0 .625H7a.313.313 0 0 1-.313-.312zm1.562 7.5c0-.172.14-.313.313-.313h6.874a.313.313 0 0 1 0 .625H8.564a.313.313 0 0 1-.313-.312zm1.266-4.375a.625.625 0 1 1-1.25 0 .625.625 0 0 1 1.25 0zm3.515-3.348 1.153-1.152c.836-.836 2.23-.7 2.886.285l.192.29a.31.31 0 0 1-.086.433.31.31 0 0 1-.434-.086l-.191-.29a1.252 1.252 0 0 0-1.926-.19l-1.152 1.152a.314.314 0 0 1-.442 0 .314.314 0 0 1 0-.442zm2.735 3.348a.625.625 0 1 1-1.25 0 .625.625 0 0 1 1.25 0z"
    />,
    <path
      fill="#2B2C3D"
      d="M12 2.625a9.376 9.376 0 1 1 0 18.751 9.376 9.376 0 0 1 0-18.751zM12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20zM9.516 11.375a.625.625 0 1 0-1.25 0 .625.625 0 0 0 1.25 0zM15.14 12a.625.625 0 1 0 0-1.25.625.625 0 0 0 0 1.25zm1.406-4.492.191.289a.31.31 0 0 0 .434.086.31.31 0 0 0 .086-.434l-.192-.289a1.876 1.876 0 0 0-2.886-.285l-1.153 1.152a.314.314 0 0 0 0 .442c.121.12.32.12.442 0l1.152-1.153a1.252 1.252 0 0 1 1.926.192zm-9.86.742c0 .172.141.313.313.313h2.5a.313.313 0 0 0 0-.625H7a.313.313 0 0 0-.313.312zm1.875 7.188a.313.313 0 0 0-.312.312c0 .172.14.313.313.313h6.874a.313.313 0 0 0 0-.625H8.564z"
    />,
  ],
  defaultProps: {
    "aria-label": "Confused face"
  }
});

export default Challenging;
